var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',[_c('div',{staticClass:"block-div"}),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-box"},[_c('img',{attrs:{"src":require("../assets/images/loading-square.gif"),"alt":""}})])
}]

export { render, staticRenderFns }